import {Component, Input, OnInit} from '@angular/core';
import {CustomerAreaPosition, SubscriberComponent, Tab, TabSearchResult, TabService} from 'brewbill-lib';

@Component({
    selector: 'bb-tab-card-header',
    templateUrl: './tab-card-header.component.html',
    styleUrls: ['./tab-card-header.component.scss'],
})
export class TabCardHeaderComponent extends SubscriberComponent implements OnInit {
    @Input() tab: TabSearchResult | Tab;
    @Input() editable = false;

    email: string;
    name: string;
    editNameOverride = false;
    customerAreaPosition: CustomerAreaPosition;

    constructor(private tabService: TabService) {
        super();
    }

    ngOnInit() {
        this.subscribe(this.tabService.event.subscribe(t => {
            if (!!t && !!this.tab && t.id === this.tab.id) {
                this.init(t);
            }
        }));
        this.init(this.tab);
    }

    init(t: any) {
        this.editNameOverride = false;
        if (!!t && t.paymentInformation !== undefined) {
            this.tab = t as Tab;
            if (!!this.tab.nameOverride) {
                this.name = this.tab.nameOverride;
            } else {
                this.name = !!this.tab.person ? this.tab.person.name : 'Terminal Order';
            }
            this.email = !!this.tab.person ? this.tab.person.email : '';
            this.customerAreaPosition = !!this.tab.customerAreaPosition ? new CustomerAreaPosition(this.tab.customerAreaPosition) : null;
        } else {
            this.tab = this.tab as TabSearchResult;
            this.name = !!this.tab.name ? this.tab.name : 'Terminal Order';
            this.email = this.tab.email;
        }
    }

    getServerName() {
        if ((this.tab as Tab).server !== undefined) {
            const server = (this.tab as Tab).server;
            return !!server ? server.name : '';
        } else {
            return (this.tab as TabSearchResult).serverName;
        }
    }

    editName(event) {
        event.stopPropagation();
        this.editNameOverride = true;
    }

    getTab() {
        return this.tab as Tab;
    }
}
